import { lazy } from 'react';
export var BasePageAsync = lazy(function () { return import('./BasePage'); });
